/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_COUPONS = gql`
  query GetCoupons($filters: CouponFilterInput, $options: GetManyOptions) {
    getCoupons(filters: $filters, options: $options) {
      count
      content {
        id
        name
        couponCode
        discountType
        couponType
        value
        image
        startDate
        endDate
        usageLimit
        usedCount
        presentation {
          name
          id
        }
        section {
          name
          id
        }
        sectionOptType {
          name
          id
        }
        isActive
        status
      }
    }
  }
`;
